import React from 'react';

interface EducationDetailTabProps {
  employeeData: any;
}

const formatEducationLevel = (level: string | null | undefined) => {
  if (!level) return '-';
  const levelMap: Record<string, string> = {
    sd: 'SD',
    smp: 'SMP',
    sma: 'SMA/SMK',
    d3: 'D3',
    s1: 'S1',
    s2: 'S2',
    s3: 'S3',
  };
  return levelMap[level] || level;
};

export default function EducationDetailTab({ employeeData }: EducationDetailTabProps) {
  const educationHistory = employeeData.education_history || [];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Data Pendidikan</h3>
        <p className="text-gray-500 text-sm">Riwayat pendidikan formal pegawai</p>
      </div>

      {educationHistory.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <p>Tidak ada data riwayat pendidikan</p>
        </div>
      ) : (
        <div className="space-y-4">
          {educationHistory.map((edu: any, index: number) => (
            <div key={index} className="border-2 rounded-lg p-4 space-y-3 bg-gray-50">
              <h4 className="font-medium text-gray-900">Pendidikan #{index + 1}</h4>
              <div className="grid md:grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Jenjang</label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {formatEducationLevel(edu.level)}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nama Institusi
                  </label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {edu.institution || '-'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Jurusan</label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {edu.major || '-'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tahun Lulus
                  </label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {edu.year_end || '-'}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
